import { Person, PersonMinimal } from '@/types/person';

const formatPersonName = ({
  person,
  withNickname = true,
  withPronouns = true,
  lastInitialOnly = false
}: {
  person: Person | PersonMinimal;
  withNickname?: boolean;
  withPronouns?: boolean;
  lastInitialOnly?: boolean;
}): string => {
  const { first_name, last_name, nickname, pronouns } = person;
  let name = '';

  if (first_name) {
    name += first_name;
  }

  if (withNickname && nickname) {
    name += ` "${nickname}"`;
  }

  if (last_name) {
    name += lastInitialOnly ? ` ${last_name[0]}.` : ` ${last_name}`;
  }

  if (pronouns && withPronouns) {
    name += ` (${pronouns})`;
  }

  return name;
};

export default formatPersonName;
